import { render } from "./WatchManIndex.vue?vue&type=template&id=4b07e756&scoped=true"
import script from "./WatchManIndex.vue?vue&type=script&lang=js"
export * from "./WatchManIndex.vue?vue&type=script&lang=js"

import "./WatchManIndex.vue?vue&type=style&index=0&id=4b07e756&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b07e756"]])

export default __exports__